import React, { useState, useEffect } from 'react';
import { usePayDataContext } from '../contexts/PayDataContext';


const CountdownTimer = ({onTimerExpired}) => {
    const { resetTimer } = usePayDataContext();

    const initialCountdownSeconds = 300 * 6; 
    const [seconds, setSeconds] = useState(
        parseInt(localStorage.getItem('countdownSeconds')) || initialCountdownSeconds
    );

    useEffect(() => {
        const intervalId = setInterval(() => {
            const startTime = parseInt(localStorage.getItem('startTime')) || Date.now();
            const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
            const remainingSeconds = initialCountdownSeconds - elapsedTime;

            if (remainingSeconds >= 0) {
                setSeconds(remainingSeconds);
                localStorage.setItem('countdownSeconds', remainingSeconds);
            } else {
                clearInterval(intervalId);
                onTimerExpired()
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [initialCountdownSeconds]);

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const remainingSeconds = time % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    return (
        <div>
            <p className="text-xs text-center">
                Expires in&nbsp;    <span className="text-green-600">{formatTime(seconds)}</span>
            </p>
        </div>
    );
};

export default CountdownTimer;
